import { render, staticRenderFns } from "./vliveAdv.vue?vue&type=template&id=4d6a0040&"
import script from "./vliveAdv.vue?vue&type=script&lang=js&"
export * from "./vliveAdv.vue?vue&type=script&lang=js&"
import style0 from "./vliveAdv.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports